const isIPAddress = (str: string) => {
    const ipPattern = /^(\d{1,3}\.){3}\d{1,3}$/;
    const urlPattern = /^(http|https):\/\/(\d{1,3}\.){3}\d{1,3}/;
    return ipPattern.test(str) || urlPattern.test(str);
};

let environment = 'production';
if (import.meta.env.VITE_HOSTED_URL?.includes('dev')) {
    environment = 'development';
} else if (import.meta.env.VITE_HOSTED_URL?.includes('preview')) {
    environment = 'preview';
} else if (import.meta.env.VITE_HOSTED_URL?.includes('feature')) {
    environment = 'feature';
} else if (isIPAddress(`${import.meta.env.VITE_HOSTED_URL}`)) {
    environment = 'local';
}

export const getEnvironment = () => {
    return environment;
};